module.exports = __webpack_public_path__ + "static/media/CreditCardAutorization.5e202bbb.pdf";